import { render, staticRenderFns } from "./ProductSpecificationsList.vue?vue&type=template&id=39ae8298"
import script from "./ProductSpecificationsList.vue?vue&type=script&lang=js"
export * from "./ProductSpecificationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports